var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful/components/image-macro.j2"] = require( "macros/contentful/components/image-macro.j2" );
dependencies["contentful/giveaway-component-coming-soon.j2"] = require( "contentful/giveaway-component-coming-soon.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/giveaway-component.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful/components/image-macro.j2", false, "core/templates/contentful/giveaway-component.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("buildImage")) {
var t_4 = t_1.buildImage;
} else {
cb(new Error("cannot import 'buildImage'")); return;
}
context.setVariable("buildImage", t_4);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")) {
output += "<div class=\"c-giveaway\">\n\n        ";
if((lineno = 6, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"coming_soon"]))) {
output += "\n\n            ";
env.getTemplate("contentful/giveaway-component-coming-soon.j2", false, "core/templates/contentful/giveaway-component.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n        ";
})});
}
else {
output += "\n\n            <a class=\"c-giveaway__link js-giveaway__link\"\n                href=\"?id=";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"campaignId"), env.opts.autoescape);
output += "#giveaway\"\n                data-campaign-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"campaignId"), env.opts.autoescape);
output += "\"\n                data-qa-giveaway-link\n                ";
output += runtime.suppressValue((lineno = 16, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 16, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"giveaways | click",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"giveawayTitle")])), env.opts.autoescape);
output += ">";
if((lineno = 18, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.primaryImage"]))) {
output += "\n\n                    ";
output += runtime.suppressValue((lineno = 20, colno = 31, runtime.callWrap(t_4, "buildImage", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"primaryImage"),runtime.makeKeywordArgs({"experience": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")})])), env.opts.autoescape);
output += "\n\n                ";
;
}
output += "\n\n                <div class=\"c-giveaway__inner\">";
if((lineno = 26, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.daysUntilExpiration"]))) {
output += "<h3 class=\"c-giveaway__expiration\"\n                            data-qa-giveaway-expiration>\n                            ";
output += runtime.suppressValue((lineno = 29, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["giveaways-expires-in-x-days",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"daysUntilExpiration")]})])), env.opts.autoescape);
output += "\n                        </h3>\n                    ";
;
}
if((lineno = 33, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.giveawayTitle"]))) {
output += "<h3 class=\"c-giveaway__title\"\n                            data-qa-giveaway-title>\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"giveawayTitle"), env.opts.autoescape);
output += "\n                        </h3>\n                    ";
;
}
output += "\n\n                </div>\n\n            </a>\n\n        ";
;
}
output += "\n\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/giveaway-component.j2"] , dependencies)